import { css } from 'aphrodite';
import * as React from 'react';
import { Waypoint } from 'react-waypoint';
import { useKeepInTouchAllScores } from '../../../../../queries/KeepInTouchAgent';
import { Button } from '../../../../components-v2/Button';
import { Skeleton } from '../../../../components-v2/Skeleton';
import { LoadingSpinner } from '../../../../components/LoadingSpinner';
import { ScoreCard } from '../ScoresView/ScoreCard';
import { ScoreFilters, ScoreFilterState } from '../ScoresView/ScoreFilters';
import { styleSheet } from '../ScoresView/styles';

const PAGE_SIZE = 25;

interface TopContactsViewProps {
	onManageJobs: () => void;
}

export const TopContactsView: React.FC<TopContactsViewProps> = ({ onManageJobs }) => {
	const [filters, setFilters] = React.useState<ScoreFilterState>({ showSuppressed: false, ownerOnly: false });
	const { data, isLoading, isFetchingNextPage, hasNextPage, fetchNextPage } = useKeepInTouchAllScores({
		pageSize: PAGE_SIZE,
		ownerOnly: filters.ownerOnly,
	});

	const allScores = data?.pages.flatMap(page => page.values) ?? [];

	const handleLoadMore = () => {
		if (!isFetchingNextPage && hasNextPage) {
			fetchNextPage();
		}
	};

	if (isLoading) {
		return (
			<div>
				<Skeleton style={{ height: 72, marginBottom: 12 }} />
				<Skeleton style={{ height: 72, marginBottom: 12 }} />
				<Skeleton style={{ height: 72 }} />
			</div>
		);
	}

	// No scores at all — caller should show config management instead
	if (allScores.length === 0) {
		return null;
	}

	return (
		<>
			<div className={css(styleSheet.header)}>
				<h2 className={css(styleSheet.configName)}>Top Contacts</h2>
				<Button variant='outline' size='sm' onClick={onManageJobs}>
					Manage Jobs
				</Button>
			</div>
			<ScoreFilters filters={filters} onChange={setFilters} />
			<div className={css(styleSheet.list)}>
				{allScores.map(score => (
					<ScoreCard
						key={score.id}
						score={score}
						configId={score.jobConfigurationId}
						showSuppressed={filters.showSuppressed}
					/>
				))}
				{hasNextPage ? (
					<Waypoint onEnter={handleLoadMore}>
						<div className={css(styleSheet.loadingMore)}>
							<LoadingSpinner type='small' />
						</div>
					</Waypoint>
				) : null}
			</div>
		</>
	);
};
